export type PickState = { digits: (number | null)[]; focus: number };

export function emptyPick(len: number): PickState {
  return { digits: Array.from({ length: len }, () => null), focus: 0 };
}

export function clearPick(len: number): PickState {
  return emptyPick(len);
}

export function focusAt(s: PickState, index: number): PickState {
  if (index < 0 || index >= s.digits.length) throw new RangeError(`focus out of range: ${index}`);
  return { ...s, focus: index };
}

export function setDigit(s: PickState, index: number, value: number): PickState {
  if (index < 0 || index >= s.digits.length) throw new RangeError(`index out of range: ${index}`);
  if (!Number.isInteger(value) || value < 0 || value > 9) {
    throw new RangeError(`digit must be 0-9, got: ${value}`);
  }
  const digits = s.digits.slice();
  digits[index] = value;
  // 顺序填号时自动跳下一位；回头修改已填位时焦点留在原地 ——
  // 跳走会让用户以为自己改错了地方
  const wasSequentialFill = s.focus === index && s.digits[index] === null;
  const next = wasSequentialFill ? Math.min(index + 1, digits.length - 1) : s.focus;
  return { digits, focus: next };
}

export function randomPick(len: number, rng: () => number): PickState {
  const digits = Array.from({ length: len }, () => Math.floor(rng() * 10));
  return { digits, focus: len - 1 };
}

export function isComplete(s: PickState): boolean {
  return s.digits.every((d) => d !== null);
}

export function pickString(s: PickState): string | null {
  return isComplete(s) ? s.digits.join('') : null;
}
